import React from "react";
import {
  defineBlock,
  smartProps,
  useInspectorControl,
  useSmartProp,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import style from "./block.module.scss";
import EditableText from "../shared/editable-text";
import Button from "../shared/button-icon";
import { useMediaQuery } from "@material-ui/core";
import Carte from "./carte.svg";
import CarteMobile from "./carte-mobile.svg";
import { ReactComponent as Icon } from "./icon.svg";

function Inspector() {
  const [text, setText] = useSmartProp("buttonText");
  const [link, setLink] = useSmartProp("link");
  return (
    <>
      <PanelBody title="Configuration bouton" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Texte Bouton"}
            value={text}
            onChange={(value) => setText(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Lien Bouton"}
            value={link}
            onChange={(value) => setLink(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ title, image, buttonText, link }) {
  const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);
  useInspectorControl(Inspector);
  return (
    <div className={style.block}>
      <div className={style.content}>
        <img
          src={isMobile ? CarteMobile : Carte}
          className={style.map}
          alt="Carte"
        />
        <div className={style.textBlock}>
          <EditableText
            tagName="h2"
            className={style.title}
            formattingControls={["bold", "italic"]}
            smartProp="title"
            placeholder={"Entrez un titre"}
          />
          <div className={style.bar} />
          <EditableText
            className={style.text}
            formattingControls={["bold", "italic"]}
            smartProp="text"
            placeholder={"Entrez un texte"}
          />
          {link && (
            <Button
              Icon={Icon}
              classIcon={style.icon}
              textColor={style.blueText}
              className={style.button}
              href={link}
            >
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault("La carte des châteaux"),
    text: smartProps.string.withDefault(""),
    buttonText: smartProps.string.withDefault(
      "Découvrir la carte des châteaux"
    ),
    link: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Carte des châteaux",
  },
});
